<template>
<div>
  
  <!-- BOC:[table] -->
  <PageParticipant
    role="Moderator"
    :model="model"
    :url="`${$api.servers.backend}/v1/event/${parent.id}/participant`"
    :isSearchable="true"
    :parent="parent"
    :modelParent="modelParent"
  ></PageParticipant>
  <!-- EOC -->
</div>
</template>

<script>
  //BOC:[model]
  import modelParent from '@/models/items/event'
  import model from '@/models/items/participant'
  //EOC
  //BOC:[table]
  import PageParticipant from "@/components/Bread/Event/Student/PageParticipant";
  //EOC
  import { mapState } from 'vuex'
  export default {
    components:{
      //BOC:[table]
      PageParticipant,
      //EOC
    },
    computed: mapState({
      school: state => state.school.data,
    }),
    props:[
      'role',
      'parent',
    ],
    data:()=>({
      //BOC:[model]
      modelParent:modelParent,
      model: model,
      //EOC
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>